import styled from "styled-components";

export const StyledUnderline = styled.span`
  border-bottom: 1px dashed var(--gray-900);
  padding-bottom: 1px;
`;

export const StyledTable = styled.table`
  border-top: none;
  border-left: none;
  border-right: none;
  table-layout: fixed;

  thead {
    border-collapse: separate;
    border-bottom: 1px solid var(--gray-500);

    tr th {
      font-weight: 400;
      font-size: 12px;
      color: var(--charcoal-300);
    }
  }
`;
